import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getField = id => {
  return http.get(
    `${getBaseUrl()}/field/${id}`
  );
};

export const getFields = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/field`
    );
  }
  return http.get(
    `${getBaseUrl()}/field?${paginate}`
  );
};

export const updateField = data => {

  return http.put(
    `${getBaseUrl()}/field/${data.id}`,
    data
  );
};
export const submitField = data => {

  return http.post(
    `${getBaseUrl()}/field`,
    data
  );
};
